const firebaseConfig = {
  apiKey: "AIzaSyDdhvAY1gdIox7179v5vLInBcZoRIf0KK4",
  authDomain: "walk-seattle.firebaseapp.com",
  databaseURL: "https://walk-seattle-default-rtdb.firebaseio.com",
  projectId: "walk-seattle",
  storageBucket: "walk-seattle.appspot.com",
  messagingSenderId: "884186118910",
  appId: "1:884186118910:web:e3a4fe4896267008d703af"
};

export default firebaseConfig;